module.exports = __webpack_public_path__ + "img/certik-small.6034a721.svg";